import { GlobalToken } from 'antd';
import styled from 'styled-components';

export const ThankYouScreenContainer = styled.div<{ theme: { token: GlobalToken } }>`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0;
  margin: 0;
  position: absolute;
  top: 0;
  left: 0;
  gap: 32px;

  .spinner-container {
    height: fit-content;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 16px;

    .ant-spin {
      color: ${props => props.theme.token.colorPrimary};
    }
  }

  .text-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    gap: 8px;
    width: 100%;
  }

  .title {
    text-align: center;
    color: ${props => props.theme.token.colorText || 'white'};
    font-size: 38px;
    font-family: ${props => props.theme.token.fontFamily || 'Heebo'};
    font-weight: 600;
    line-height: 46px;
    word-wrap: break-word;
  }

  .description {
    align-self: stretch;
    text-align: center;
    color: ${props => props.theme.token.colorText || 'white'};
    font-size: 16px;
    font-family: ${props => props.theme.token.fontFamily || 'Heebo'};
    font-weight: 400;
    line-height: 24px;
    word-wrap: break-word;
  }
`;
